document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.pumpTypeCategories');
    
    containers.forEach(container => {
        const post_item = container.parentElement.parentElement;
        const inner = container.querySelector('.pumpTypeCategories--inner');

        if (container && inner) {
            post_item.addEventListener('mouseenter', function() {
                if (inner.scrollWidth > container.clientWidth) {
                    startScrolling(inner, container.clientWidth);
                }
            });

            post_item.addEventListener('mouseleave', function() {
                stopScrolling(inner, container.clientWidth);
            });
        }
    });

    function startScrolling(element, containerWidth) {
        const scrollAmount = (element.scrollWidth - containerWidth) + 50;
        const duration = scrollAmount / 50;

        function scrollToEnd() {
            element.style.transition = `transform ${duration}s linear`;
            element.style.transform = `translateX(-${scrollAmount}px)`;
        }

        function scrollToStart() {
            element.style.transition = `transform ${duration}s linear`;
            element.style.transform = 'translateX(0)';
        }

        function loopScroll() {
            scrollToEnd();
            element.addEventListener('transitionend', function() {
                scrollToStart();
                element.addEventListener('transitionend', loopScroll, { once: true });
            }, { once: true });
        }

        loopScroll();
    }

    function stopScrolling(element, containerWidth) {
        element.style.transition = `transform 1s linear`;
        element.style.transform = 'translateX(0)';
    }
});